import ResponsiveRow from './ResponsiveRow';
const PROFILE_TABS = [
    ['overview', 'Overview'],
    ['activity', 'Activity'],
    ['settings', 'Settings'],
];

export function RecordCardProfileTabs({ activeTab, onChange, tabs = PROFILE_TABS }) {
    return (
        <ResponsiveRow className="mt-3 flex gap-1 flex-wrap">
            {tabs.map(([key, label]) => (
                <button
                    key={key}
                    type="button"
                    onClick={() => onChange(key)}
                    className={`ia-hover-pulse rounded-full border bg-transparent px-3 py-1.5 text-xs font-medium transition
                        ${activeTab === key
                            ? 'ia-selected-pill border-[var(--selected-pill-border)] text-[var(--selected-pill-ink)]'
                            : 'border-[var(--surface-border)] text-[var(--ink-muted)]'}`}
                >
                    {label}
                </button>
            ))}
        </ResponsiveRow>
    );
}

export function RecordCardActionButton({ children, className = '', ...props }) {
    return (
        <button
            type="button"
            className={`ia-hover-pulse rounded-full border border-[var(--surface-border)] bg-transparent px-4 py-2 text-sm font-medium text-[var(--ink)] disabled:cursor-not-allowed disabled:opacity-50 ${className}`}
            {...props}
        >
            {children}
        </button>
    );
}

export function RecordCardDeleteChoices({
    message,
    archiveDescription = 'Archive keeps the record for history and can be reversed later. Delete permanently removes it.',
    archiveLabel = 'Archive',
    deleteLabel = 'Delete permanently',
    archiveBusy = false,
    deleteBusy = false,
    disabled = false,
    onArchive,
    onDelete,
    onCancel,
}) {
    return (
        <div className="mt-4 rounded-lg border border-[var(--ui-alert)]/50 bg-[var(--ui-alert)]/10 p-3">
            <div className="text-sm font-medium text-[var(--ui-alert)]">{message}</div>
            <div className="mt-1 text-xs text-[var(--ui-alert)]">{archiveDescription}</div>
            <ResponsiveRow className="mt-3 flex flex-wrap justify-center gap-2">
                <RecordCardActionButton onClick={onArchive} disabled={disabled} className="text-[var(--ui-alert)]">
                    {archiveBusy ? 'Working…' : archiveLabel}
                </RecordCardActionButton>
                <RecordCardActionButton onClick={onDelete} disabled={disabled} className="text-[var(--ui-alert)]">
                    {deleteBusy ? 'Working…' : deleteLabel}
                </RecordCardActionButton>
                <RecordCardActionButton onClick={onCancel} disabled={disabled}>
                    Cancel
                </RecordCardActionButton>
            </ResponsiveRow>
        </div>
    );
}
